(() => {
  window.addEventListener('scroll', function () {
    const msgObj = document.getElementById("message");
    const rsvpTxtObj = document.getElementById("rsvp");
    if ((msgObj && msgObj.getBoundingClientRect().top + window.innerHeight > window.scrollY) ||
        (rsvpTxtObj && rsvpTxtObj.getBoundingClientRect().top > window.scrollY)) {
      document.getElementById('sample-under-banner__area').classList.remove("js-is-show");
    } else {
      document.getElementById('sample-under-banner__area').classList.add("js-is-show");
    }
  });
})();